// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"876f3b7a","488":"9e7d067e","513":"db4398b0","645":"9eb23d6a","705":"7d670afd","727":"d5bd26e4","763":"2b29c882","787":"fa223865"}[chunkId] + ".chunk.js";
};